import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _styled from "@emotion/styled/base";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Image from 'next/image';
import * as React from 'react';

var RawCoin = function RawCoin(_ref) {
  var src = _ref.src,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1.75rem' : _ref$width,
      className = _ref.className,
      name = _ref.name;
  var option = {
    style: {
      width: '1em',
      height: '1em',
      fontSize: width,
      position: 'relative'
    },
    className: className
  };
  var formatSrc = React.useMemo(function () {
    if (name && name !== null && name !== void 0 && name.includes('DOP-3P-LP')) {
      return '/images/coin/dolly-pool.svg';
    }

    if (src) {
      return src;
    }

    return 'https://bscscan.com/images/main/empty-token.png';
  }, [src, name]);
  return _jsx("div", _objectSpread(_objectSpread({}, option), {}, {
    children: _jsx(Image, {
      src: formatSrc,
      height: 64,
      width: 64,
      alt: name
    })
  }));
};

export var Coin = /*#__PURE__*/React.memo( /*#__PURE__*/_styled(RawCoin, true ? {
  target: "e1qq5bdd0"
} : {
  target: "e1qq5bdd0",
  label: "Coin"
})(true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvYXBwcy9mcm9udGVuZC9zcmMvY29tcG9uZW50cy9Db2luL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQzhDIiwiZmlsZSI6Ii92ZXJjZWwvcGF0aDAvYXBwcy9mcm9udGVuZC9zcmMvY29tcG9uZW50cy9Db2luL2luZGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IEltYWdlIGZyb20gJ25leHQvaW1hZ2UnXG5pbXBvcnQgKiBhcyBSZWFjdCBmcm9tICdyZWFjdCdcblxuZXhwb3J0IHR5cGUgQ29pblByb3BzID0ge1xuICBuYW1lOiBzdHJpbmdcbiAgc3JjPzogc3RyaW5nXG4gIHdpZHRoPzogc3RyaW5nIHwgbnVtYmVyXG4gIGNsYXNzTmFtZT86IHN0cmluZ1xufVxuXG5jb25zdCBSYXdDb2luOiBSZWFjdC5GQzxDb2luUHJvcHM+ID0gKHsgc3JjLCB3aWR0aCA9ICcxLjc1cmVtJywgY2xhc3NOYW1lLCBuYW1lIH0pID0+IHtcbiAgY29uc3Qgb3B0aW9uID0ge1xuICAgIHN0eWxlOiB7XG4gICAgICB3aWR0aDogJzFlbScsXG4gICAgICBoZWlnaHQ6ICcxZW0nLFxuICAgICAgZm9udFNpemU6IHdpZHRoLFxuICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZSdcbiAgICB9IGFzIFJlYWN0LkNTU1Byb3BlcnRpZXMsXG4gICAgY2xhc3NOYW1lXG4gIH1cblxuICBjb25zdCBmb3JtYXRTcmMgPSBSZWFjdC51c2VNZW1vKCgpID0+IHtcbiAgICBpZiAobmFtZSAmJiBuYW1lPy5pbmNsdWRlcygnRE9QLTNQLUxQJykpIHtcbiAgICAgIHJldHVybiAnL2ltYWdlcy9jb2luL2RvbGx5LXBvb2wuc3ZnJ1xuICAgIH1cbiAgICBpZiAoc3JjKSB7XG4gICAgICByZXR1cm4gc3JjXG4gICAgfVxuICAgIHJldHVybiAnaHR0cHM6Ly9ic2NzY2FuLmNvbS9pbWFnZXMvbWFpbi9lbXB0eS10b2tlbi5wbmcnXG4gIH0sIFtzcmMsIG5hbWVdKVxuXG4gIHJldHVybiAoXG4gICAgPGRpdiB7Li4ub3B0aW9ufT5cbiAgICAgIDxJbWFnZSBzcmM9e2Zvcm1hdFNyY30gaGVpZ2h0PXs2NH0gd2lkdGg9ezY0fSBhbHQ9e25hbWV9IC8+XG4gICAgPC9kaXY+XG4gIClcbn1cbmV4cG9ydCBjb25zdCBDb2luID0gUmVhY3QubWVtbyhzdHlsZWQoUmF3Q29pbilgYClcbiJdfQ== */"));